import React from 'react';
import Create from './pages/Create';
import Edit from './pages/Edit';
import Index from './pages/Index';
import { AppRouteProps } from '~/routes';

export default function AgencyRoutes(): readonly AppRouteProps[] {
  const routes: AppRouteProps[] = [
    {path: '/agency', component: Index, isProtected: true, permissions: ['agency_index']},
    {path: '/agency/create', component: Create, isProtected: true, permissions: ['agency_create']},
    {path: '/agency/edit/:id', component: Edit, isProtected: true, permissions: ['agency_edit']},

  ];

  return routes;
}
